export default __webpack_public_path__ + "71595b68db0e2a931e68a96e245f002c.svg";